import { Link } from "react-router-dom";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

export default function MessageSection() {
  const { ref: sectionRef, isVisible } = useScrollAnimation({ threshold: 0.1 });
  const { ref: img1Ref, isVisible: img1Visible } = useScrollAnimation({ threshold: 0.2 });
  const { ref: img2Ref, isVisible: img2Visible } = useScrollAnimation({ threshold: 0.2 });

  return (
    <section
      id="about"
      className="py-20 bg-white"
      ref={sectionRef as React.RefObject<HTMLElement>}
    >
      <div className="max-w-[1240px] mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          {/* Text */}
          <div className="flex-1">
            <p
              className="text-[#3ab5c6] text-xs font-['Poppins'] tracking-widest mb-3"
              style={{
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? "translateX(0)" : "translateX(-20px)",
                transition: "opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s",
              }}
            >
              FUTURE DIVER
            </p>
            <h2
              className="text-2xl md:text-3xl font-bold text-gray-800 leading-snug mb-6"
              style={{
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? "translateY(0)" : "translateY(20px)",
                transition: "opacity 0.8s ease 0.2s, transform 0.8s ease 0.2s",
              }}
            >
              未来という海を、<br />ともに泳ぎ進む。
            </h2>
            <div
              className="space-y-4 text-sm text-gray-600 leading-relaxed"
              style={{
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? "translateY(0)" : "translateY(20px)",
                transition: "opacity 0.8s ease 0.35s, transform 0.8s ease 0.35s",
              }}
            >
              <p>
                FDは「<span className="text-[#3ab5c6] font-medium">Future Diver</span>」の頭文字。<br />
                未来を広大な海と捉え、その海を恐れず好奇心を持って泳ぎ進む<span className="text-[#3ab5c6] font-medium">ダイバー</span>のように——<br />
                私たちは、お客様や地域社会とともに、新しい未来へと向かっていきます。
              </p>
              <p>
                現在は愛知県刈谷市を拠点に、訪問介護事業所「ヘルパーステーションみりん」を運営しています。<br />
                一人ひとりの暮らしに寄り添い、その人らしい毎日を支えることが、私たちの出発点です。
              </p>
              <p>
                福祉・介護の枠を超え、様々な分野で人々の生活を豊かにするサービスへ。<br />
                これはまだ、始まりに過ぎません。
              </p>
            </div>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 mt-8 border border-[#3ab5c6] text-[#3ab5c6] text-sm px-6 py-2.5 rounded-full hover:bg-[#3ab5c6] hover:text-white transition-colors cursor-pointer whitespace-nowrap"
              style={{
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? "translateY(0)" : "translateY(20px)",
                transition: "opacity 0.8s ease 0.5s, transform 0.8s ease 0.5s",
              }}
            >
              <span>›</span> 株式会社FDについて
            </Link>
          </div>

          {/* Images — オリジナル写真に差し替え */}
          <div className="flex-1 flex gap-4 items-end relative">
            <div
              className="w-1/2 h-64 md:h-80 rounded-2xl overflow-hidden"
              ref={img1Ref as React.RefObject<HTMLDivElement>}
              style={{
                opacity: img1Visible ? 1 : 0,
                transform: img1Visible ? "translateY(0) scale(1)" : "translateY(30px) scale(0.97)",
                transition: "opacity 0.9s ease 0.2s, transform 0.9s ease 0.2s",
              }}
            >
              <img
                src="https://static.readdy.ai/image/e643b173cc54a8b3f926f18f1e409a57/ecbfb6b2971832a8bb15c419950f2eca.png"
                alt="みりんスタッフ"
                className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div
              className="w-1/2 h-52 md:h-64 rounded-2xl overflow-hidden mb-8"
              ref={img2Ref as React.RefObject<HTMLDivElement>}
              style={{
                opacity: img2Visible ? 1 : 0,
                transform: img2Visible ? "translateY(0) scale(1)" : "translateY(50px) scale(0.97)",
                transition: "opacity 0.9s ease 0.45s, transform 0.9s ease 0.45s",
              }}
            >
              <img
                src="https://static.readdy.ai/image/e643b173cc54a8b3f926f18f1e409a57/2e84197229a1364f539250dc2d659ab2.jpeg"
                alt="在宅ケアの様子"
                className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700"
              />
            </div>

          </div>
        </div>
      </div>

    </section>
  );
}
